import classNames from 'classnames'
import Icon from '@dustin-web/microsite-components/src/icon'
import TagSearchEvent from './tag-search-event'

export type SearchProps = {
  className?: string
  url: string
  title: string
}

const TagSearch = ({ title, className, url }: SearchProps) => {
  const tagId = `tag-${title}-${Math.random().toString(36).substring(2, 9)}`

  return (
    <button id={tagId} className={classNames('c-pill', className)}>
      <TagSearchEvent targetId={tagId} url={url} />
      <Icon className="i-16 u-mr-8" name='search' />
      <span>{title}</span>
    </button>
  )
}

export default TagSearch
